import { ModelMapper } from "@omni/types/utils/modelMapper";

const fromEntitiesResponse =
    <TIn, TOut>(
        mapper: ModelMapper<TIn, TOut>
    ): ModelMapper<{ entities: Array<TIn> }, Array<TOut>> =>
    (model) => {
        return model.entities.map(mapper);
    };

const fromList =
    <TIn, TOut>(
        mapper: ModelMapper<TIn, TOut>
    ): ModelMapper<Array<TIn>, Array<TOut>> =>
    (model) => {
        return model.map(mapper);
    };

export const ProductsMapper = {
    fromEntitiesResponse: fromEntitiesResponse,
    fromList: fromList
};
